import React from "react";
import PropTypes from "prop-types";
import styles from "./ChooseFeedTypeList.module.css";
import TemplateButton from "../TemplateButton";

/**
 * Interactive component. A list of feed templates that a user can choose from.
 */

export function ChooseFeedTypeList({
  onStandardContent,
  onStandingOrder,
  onBanner,
}) {
  return (
    <div className={styles.container}>
      <h2 className={styles.header}>Select Template:</h2>
      <div className={styles.iconContainer}>
        <div className={styles.icon} onClick={onStandardContent}>
          <TemplateButton feedType="Standard Content" />
        </div>
        <div className={styles.icon} onClick={onStandingOrder}>
          <TemplateButton feedType="Standing Order" />
        </div>
        <div className={styles.icon} onClick={onBanner}>
          <TemplateButton feedType="Banner" />
        </div>
      </div>
    </div>
  );
}

ChooseFeedTypeList.propTypes = {
  /**
   * Function that fires when Standard Content is chosen.
   */
  onStandardContent: PropTypes.func,
  /**
   * Function that fires when Standing Order is chosen.
   */
  onStandingOrder: PropTypes.func,
  /**
   * Function that fires when Banner is chosen.
   */
  onBanner: PropTypes.func,
};
